export default "__VITE_ASSET__BrE6$TkK__"